import { render } from "./basic-month-table.vue?vue&type=template&id=470e28bc&ts=true"
import script from "./basic-month-table.vue?vue&type=script&lang=ts"
export * from "./basic-month-table.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__